import { render } from "./vehicle-meta.vue?vue&type=template&id=61711f63"
import script from "./vehicle-meta.vue?vue&type=script&lang=js"
export * from "./vehicle-meta.vue?vue&type=script&lang=js"

import exportComponent from "/builds/bluemantis/origo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__